import PropTypes from 'prop-types';
import { toast } from 'sonner';
import { Trans, useTranslation } from 'react-i18next';
import Button from 'Components/Atoms/Button/Button';
import useCategories from 'Hooks/useCategories';
import SnackbarCard from './SnackbarCard';
import SnackbarLayout from './SnackbarLayout';
import SnackbarMedia from './SnackbarMedia';
import SnackbarContent from './SnackbarContent';
import SnackbarSmallTitle from './SnackbarSmallTitle';
import SnackbarAction from './SnackbarAction';

export default function SnackbarAutomateTagging({ id, action, concept, tagIds = [] }) {
    const { categories } = useCategories();
    const { t } = useTranslation('transactions');

    const tags = tagIds.map((tid) => categories.find((c) => c.id === tid)).filter(Boolean);

    const handleConfigure = () => {
        toast.dismiss(id);
        action?.();
    };

    return (
        <SnackbarCard>
            <SnackbarLayout>
                {tags.length > 0 && (
                    <SnackbarMedia>
                        <div className="flex -space-x-1.5">
                            {tags.map((tag) => (
                                <span
                                    key={tag.id}
                                    className="rounded-lg grid place-content-center text-xl w-9 h-9 ring-2 ring-white"
                                    style={{ backgroundColor: tag.bgColor }}
                                >
                                    {tag.icon}
                                </span>
                            ))}
                        </div>
                    </SnackbarMedia>
                )}
                <SnackbarContent>
                    <SnackbarSmallTitle>
                        <Trans
                            t={t}
                            i18nKey="automate-tagging.snackbar-message"
                            values={{ concept }}
                            components={{ strong: <strong /> }}
                        />
                    </SnackbarSmallTitle>
                </SnackbarContent>
                <SnackbarAction>
                    <Button size="small" variant="primary" onClick={handleConfigure}>
                        {t('automate-tagging.configure')}
                    </Button>
                </SnackbarAction>
            </SnackbarLayout>
        </SnackbarCard>
    );
}

SnackbarAutomateTagging.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    message: PropTypes.string,
    concept: PropTypes.string.isRequired,
    action: PropTypes.func,
    tagIds: PropTypes.arrayOf(PropTypes.string),
};
